<template>
    <div>
        <div class="ppv2-w-full">
            <h3 class="ppv2-text-center ppv2-text-blue-500 ppv2-text-2xl poppinsSemiBold">
                {{ $t('form_customer_v2.customer_alerts.title') }}
            </h3>
        </div>

        <div class="p-0">
            <div class="ppv2-flex ppv2-flex-wrap ppv2-justify-center">
                <div class="ppv2-w-full">
                    <!-- Tabs -->
                    <ul
                        class="ppv2-pl-0 ppv2-flex ppv2-items-center ppv2-border-b ppv2-border-gray-200 ppv2-bg-transparent"
                        role="tablist"
                    >
                        <li v-for="(alert, index) in alertCategories" :key="alert.id" class="nav-item">
                            <button
                                class="ppv2-px-4 ppv2-py-2 ppv2-text-sm poppinsMedium ppv2-border-b-2 ppv2-border-transparent hover:ppv2-border-blue-300"
                                :class="[
                                    isDark ? 'ppv2-text-white' : 'ppv2-text-[#0c2340]',
                                    { 'ppv2-border-[#7d2dbd] ppv2-text-[#7d2dbd]': selectedTab === alert.id },
                                ]"
                                @click="selectTab(alert.id)"
                            >
                                {{ alert.name }}
                            </button>
                        </li>
                    </ul>

                    <!-- Tab Content -->
                    <div class="ppv2-rounded ppv2-p-4 ppv2-m-0">
                        <div v-for="alert in alertCategories" :key="alert.id" v-show="selectedTab === alert.id">
                            <BaseTextarea
                                v-model="getNoteByCategoryId(alert.id).content"
                                :placeholder="$t('form_customer_v2.customer_alerts.placeholder')"
                            />

                            <div
                                v-if="alert.name.toLowerCase() === 'réservation'"
                                class="d-flex justify-content-between align-items-center my-4"
                            >
                                <BaseSwitch
                                    v-model="customer.no_show"
                                    :label="$t('form_customer_v2.customer_alerts.no_present')"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BaseSwitch from '../../Shared/BaseSwitch.vue'
import BaseTextarea from '../../Shared/BaseTextarea.vue'

export default {
    props: ['user', 'alertCategories', 'customer', 'userAlertCategories'],
    components: {
        BaseSwitch,
        BaseTextarea,
    },
    data() {
        return {
            selectedTab: this.alertCategories.length ? this.alertCategories[0].id : null,
            notes_alerts: [],
        }
    },
    computed: {
        isDark() {
            return this.theme.mode === 'dark'
        },
    },
    methods: {
        showMessageNotification(message, type) {
            this.$toast[type](message)
        },
        selectTab(tabId) {
            this.selectedTab = tabId
        },
        getNoteByCategoryId(categoryId) {
            return (
                this.notes_alerts.find((note) => note.alert_category_id === categoryId) || {
                    content: '',
                }
            )
        },
    },
    mounted() {
        this.alertCategories.forEach((category) => {
            const noteData = this.userAlertCategories[category.id]?.[0] ?? {}
            this.notes_alerts.push({
                content: noteData.content || '',
                user_id: this.user.id,
                alert_category_id: category.id,
            })
        })
    },
}
</script>
